import { svgArrows } from "./svg-arrows";

jQuery(document).ready(function ($) {

  $(".wp-block-plune-blocks-latest-posts .owl-carousel").each(function () {

    var $carousel = $(this);

    $carousel.owlCarousel({
      loop: true,
      autoplay: true,
      autoplaySpeed: 100,
      // autoplayTimeout: 10000,
      autoplayTimeout: 4000,
      dots: false,
      nav: true,
      margin: 20,
      animateOut: 'fadeOut',
      animateIn: 'fadeIn',
      autoplayHoverPause: true,
      navText: [svgArrows.left, svgArrows.right],
      responsive: {
        0: {
          items: 1
        },
        400: {
          items: 2
        },
        768: {
          items: 3
        },
        782: {
          items: 1
        },
        900: {
          items: 1
        },
        1200: {
          items: 1
        }
      }
    });
  });
});
